module.exports = __webpack_public_path__ + "fonts/GOTHICBI.abd76d61.TTF";